import React, { useCallback, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Alert, Image, notification, Typography, Upload } from "antd";

import { config } from "../../config";
import { getUserDetail } from "../../utils/helper";
import { ASSET_CATEGORIES } from "../../constants";
import { deleteMediaById } from "../../store/api/projects";

const { Text } = Typography;

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const ProjectGallery = ({ project }) => {
  const { id: projectId, album } = project;
  const { media: assets = [] } = album || {};

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const [fileList, setFileList] = useState(
    assets.map((asset) => {
      return {
        uid: asset.id,
        name: `image-${asset.id}`,
        status: "done",
        url: `${config.filesBaseUrl}/${asset.filePath}`,
      };
    })
  );

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleChange = useCallback(
    ({ fileList: newFileList, file }) => {
      if (file.status !== "done") {
        setFileList(newFileList);
      } else {
        const index = newFileList.findIndex((f) => f.uid === file.uid);

        if (index !== -1) {
          const { id, filePath } = file.response;
          newFileList[index] = {
            uid: id,
            name: `image-${id}`,
            status: "done",
            url: `${config.filesBaseUrl}/${filePath}`,
          };

          setFileList(newFileList);
        }
      }
    },
    [setFileList]
  );

  const handleRemove = (item) => {
    deleteMediaById(item.uid)
      .then(() => {
        notification.success({
          message: "Successfully removed image from project",
        });
      })
      .catch(() => {
        notification.error({ message: "Could not remove image from project" });
      });
  };

  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
      type="button"
    >
      <PlusOutlined />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  return (
    <>
      <div style={{ marginBottom: "1rem" }}>
        <Alert
          message="Recommended image size: max 1MB. Allowed upto 10 images. Refresh page if it shows error for
          some files while uploading."
          type="warning"
          style={{ marginTop: "4px", marginBottom: "16px" }}
        ></Alert>
      </div>
      <Upload
        action={`${config.apiBaseUrl}/project/uploadGallery/${projectId}`}
        data={{ category: ASSET_CATEGORIES.HOME_BANNER }}
        accept=".jpeg,.jpg,.png"
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        headers={{ Authorization: `Bearer ${getUserDetail()?.accessToken}` }}
        multiple={true}
        onChange={handleChange}
        onRemove={handleRemove}
      >
        {fileList.length >= 10 ? null : uploadButton}
      </Upload>
      {previewImage && (
        <Image
          wrapperStyle={{
            display: "none",
          }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </>
  );
};

export default ProjectGallery;
